import { cva } from 'class-variance-authority';
const avatarSizeMap = {
    default: 'size-[length:var(--avatar-size)]',
    md: 'size-[length:var(--avatar-size-md)]',
    xs: 'size-[length:var(--avatar-size-xs)]',
    sm: 'size-[length:var(--avatar-size-sm)]',
    lg: 'size-[length:var(--avatar-size-lg)]',
    xl: 'size-[length:var(--avatar-size-xl)]',
};
/** CVA variants 맵 — lab·문서용 키 추출의 SSOT. */
export const avatarCva = {
    variants: {
        size: avatarSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const avatarVariants = cva('relative flex shrink-0 overflow-hidden rounded-full', avatarCva);
/** CVA에 정의된 size 키 (삽입 순서 유지). */
export const avatarSizeKeys = Object.keys(avatarCva.variants.size);
//# sourceMappingURL=avatar.cva.js.map